/* Wishlist page: loads Plus Ultra cards via Section Rendering API
   (?section_id=ajax-card-product-plus-ultra), with collection-style
   toolbar (filter drawer, density, sort) applied client-side. */
(function () {
  const SORT_OPTIONS = [
    { value: 'manual', labelKey: 'featured' },
    { value: 'best-selling', labelKey: 'bestSelling' },
    { value: 'title-ascending', labelKey: 'az' },
    { value: 'title-descending', labelKey: 'za' },
    { value: 'price-ascending', labelKey: 'priceAsc' },
    { value: 'price-descending', labelKey: 'priceDesc' },
    { value: 'created-ascending', labelKey: 'dateAsc' },
    { value: 'created-descending', labelKey: 'dateDesc' },
  ];

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState === 'complete' || document.readyState === 'interactive') init();

  function init() {
    const root = document.querySelector('[data-hdt-wishlist-root]');
    if (!root || root.dataset.hdtWishlistReady) return;
    root.dataset.hdtWishlistReady = 'true';

    const grid = root.querySelector('[data-hdt-wishlist-grid]');
    const emptyState = root.querySelector('[data-hdt-wishlist-empty]');
    const loading = root.querySelector('[data-hdt-wishlist-loading]');
    const toolbar = root.querySelector('[data-hdt-wishlist-toolbar]');
    const countLabel = root.querySelector('[data-hdt-wishlist-count-label]');
    const activeFiltersEl = root.querySelector('[data-hdt-wishlist-active-filters]');
    const filterRoot = root.querySelector('[data-hdt-wishlist-filter]');
    const filterBody = root.querySelector('[data-hdt-wishlist-filter-body]');
    const densitySwitcher = root.querySelector('[data-hdt-density-switcher]');
    const sortRoot = root.querySelector('[data-hdt-wishlist-sort]');
    if (!grid || !emptyState || !loading) return;

    const rootUrl =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || root.dataset.rootUrl || '/';
    const cardSection = root.dataset.cardSection || 'ajax-card-product-plus-ultra';
    const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    const strings = {
      addToCart: root.dataset.stringAddToCart || 'Add to cart',
      wishlist: root.dataset.stringWishlist || 'Wishlist',
      quickView: root.dataset.stringQuickView || 'Quick view',
      soldOut: root.dataset.stringSoldOut || 'Sold out',
      close: root.dataset.stringClose || 'Close',
      filter: root.dataset.stringFilter || 'Filter',
      sort: root.dataset.stringSort || 'Sort',
      clearAll: root.dataset.stringClearAll || 'Remove all',
      vendor: root.dataset.stringVendor || 'Vendor',
      tags: root.dataset.stringTags || 'Tags',
      price: root.dataset.stringPrice || 'Price',
      featured: root.dataset.stringFeatured || 'Featured',
      bestSelling: root.dataset.stringBestSelling || 'Best selling',
      az: root.dataset.stringAz || 'Alphabetically, A-Z',
      za: root.dataset.stringZa || 'Alphabetically, Z-A',
      priceAsc: root.dataset.stringPriceAsc || 'Price, low to high',
      priceDesc: root.dataset.stringPriceDesc || 'Price, high to low',
      dateAsc: root.dataset.stringDateAsc || 'Date, old to new',
      dateDesc: root.dataset.stringDateDesc || 'Date, new to old',
      productCountOne: root.dataset.stringProductCountOne || '1 product',
      productCountOther: root.dataset.stringProductCountOther || '{{ count }} products',
      noFilterResults: root.dataset.stringNoFilterResults || 'No products match your filters.',
      priceMin: root.dataset.stringPriceMin || 'Min',
      priceMax: root.dataset.stringPriceMax || 'Max',
    };

    const state = {
      items: [],
      sort: 'manual',
      vendors: new Set(),
      tags: new Set(),
      priceMin: null,
      priceMax: null,
      renderToken: 0,
      pauseRender: false,
      inFlightKey: '',
    };

    ensureWishlistApi();
    bindToolbar();
    waitForWishlist().then(render);
    document.addEventListener('hdt:wishlist:updated', onWishlistUpdated);

    function ensureWishlistApi() {
      if (window.HdtWishlist) return;
      const STORAGE_KEY = 'hdt_wishlist';
      const read = () => {
        try {
          const raw = localStorage.getItem(STORAGE_KEY);
          const parsed = raw ? JSON.parse(raw) : [];
          return Array.isArray(parsed) ? parsed.map(String) : [];
        } catch (e) {
          return [];
        }
      };
      const write = (ids) => {
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
        } catch (e) {
          /* ignore */
        }
        document.dispatchEvent(new CustomEvent('hdt:wishlist:updated', { detail: { ids } }));
      };
      window.HdtWishlist = {
        getAll: () => read(),
        has: (id) => read().includes(String(id)),
        add(id) {
          const ids = read();
          const key = String(id);
          if (!ids.includes(key)) ids.push(key);
          write(ids);
          return ids;
        },
        remove(id) {
          const ids = read().filter((x) => x !== String(id));
          write(ids);
          return ids;
        },
        toggle(id) {
          return this.has(id) ? this.remove(id) : this.add(id);
        },
        count: () => read().length,
      };
    }

    function getHandles() {
      return window.HdtWishlist.getAll().map(String);
    }

    function waitForWishlist() {
      return Promise.resolve();
    }

    function onWishlistUpdated(event) {
      if (state.pauseRender) {
        syncHearts();
        return;
      }
      const ids = (event.detail && event.detail.ids) || getHandles();
      const cards = Array.from(grid.querySelectorAll('[data-hdt-wishlist-card]'));
      if (cards.length && ids.length < cards.length) {
        cards.forEach((card) => {
          if (!ids.includes(card.getAttribute('data-hdt-wishlist-card'))) card.remove();
        });
        state.items = state.items.filter((item) => ids.includes(item.handle));
        if (!grid.querySelector('[data-hdt-wishlist-card]')) showEmpty();
        else applyView();
        syncHearts();
        return;
      }
      const nextKey = ids.slice().sort().join('|');
      if (nextKey === state.inFlightKey) return;
      render();
    }

    function showEmpty() {
      loading.hidden = true;
      grid.hidden = true;
      grid.innerHTML = '';
      emptyState.hidden = false;
      if (toolbar) toolbar.hidden = true;
      state.inFlightKey = '';
      state.items = [];
    }

    function showLoading() {
      emptyState.hidden = true;
      loading.hidden = false;
      grid.hidden = true;
    }

    function syncHearts() {
      if (!window.HdtWishlist) return;
      grid.querySelectorAll('[data-hdt-wishlist-toggle]').forEach((toggle) => {
        const isActive = window.HdtWishlist.has(toggle.getAttribute('data-hdt-wishlist-toggle'));
        toggle.classList.toggle('is-active', isActive);
        toggle.setAttribute('aria-pressed', String(isActive));
      });
    }

    function render() {
      const handles = getHandles();
      const token = ++state.renderToken;
      const key = handles.slice().sort().join('|');
      state.inFlightKey = key;

      if (handles.length === 0) {
        showEmpty();
        return;
      }

      showLoading();

      Promise.all(handles.map((handle) => fetchWishlistItem(handle, { rootUrl, cardSection, moneyFormat, strings })))
        .then((results) => {
          if (token !== state.renderToken) return;

          const gone = results.filter((item) => item && item.gone).map((item) => item.handle);
          if (gone.length) {
            state.pauseRender = true;
            gone.forEach((handle) => window.HdtWishlist.remove(handle));
            state.pauseRender = false;
          }

          state.items = results.filter((item) => item && item.html);
          if (state.items.length === 0) {
            showEmpty();
            return;
          }

          if (toolbar) toolbar.hidden = false;
          buildFilterDrawer();
          buildSortMenu();
          applyView();
          loading.hidden = true;
          emptyState.hidden = true;
          syncHearts();
        })
        .catch(() => {
          if (token !== state.renderToken) return;
          showEmpty();
        })
        .finally(() => {
          if (token === state.renderToken) {
            loading.hidden = true;
            if (state.inFlightKey === key) state.inFlightKey = '';
          }
        });
    }

    function filteredItems() {
      return state.items.filter((item) => {
        if (state.vendors.size && !state.vendors.has(item.vendor)) return false;
        if (state.tags.size) {
          const tags = item.tags || [];
          let match = false;
          state.tags.forEach((tag) => {
            if (tags.includes(tag)) match = true;
          });
          if (!match) return false;
        }
        if (state.priceMin != null && item.price != null && item.price < state.priceMin) return false;
        if (state.priceMax != null && item.price != null && item.price > state.priceMax) return false;
        return true;
      });
    }

    function sortedItems(items) {
      const list = items.slice();
      switch (state.sort) {
        case 'title-ascending':
          return list.sort((a, b) => a.title.localeCompare(b.title));
        case 'title-descending':
          return list.sort((a, b) => b.title.localeCompare(a.title));
        case 'price-ascending':
          return list.sort((a, b) => (a.price || 0) - (b.price || 0));
        case 'price-descending':
          return list.sort((a, b) => (b.price || 0) - (a.price || 0));
        case 'created-ascending':
          return list.sort((a, b) => (a.created || 0) - (b.created || 0));
        case 'created-descending':
          return list.sort((a, b) => (b.created || 0) - (a.created || 0));
        case 'best-selling':
          return list.sort((a, b) => (b.available ? 1 : 0) - (a.available ? 1 : 0));
        default:
          return list;
      }
    }

    function applyView() {
      const visible = sortedItems(filteredItems());
      grid.innerHTML = visible
        .map(
          (item, index) =>
            `<li class="hdt-cpu-grid__item" data-hdt-wishlist-card="${escapeAttr(item.handle)}" data-vendor="${escapeAttr(item.vendor || '')}" data-price="${item.price || 0}" data-tags="${escapeAttr((item.tags || []).join(','))}" style="--animation-order: ${index + 1};">${item.html}</li>`
        )
        .join('');
      grid.hidden = visible.length === 0;
      if (visible.length === 0 && state.items.length > 0) {
        emptyState.hidden = false;
        emptyState.querySelector('.hdt-wishlist-empty__text').textContent = strings.noFilterResults;
      } else if (visible.length > 0) {
        emptyState.hidden = true;
      }
      updateCount(visible.length);
      updateActiveFilters();
      syncHearts();
    }

    function updateCount(count) {
      if (!countLabel) return;
      countLabel.textContent =
        count === 1
          ? strings.productCountOne
          : strings.productCountOther.replace('{{ count }}', String(count));
    }

    function updateActiveFilters() {
      if (!activeFiltersEl) return;
      const chips = [];
      state.vendors.forEach((vendor) => {
        chips.push({ type: 'vendor', value: vendor, label: vendor });
      });
      state.tags.forEach((tag) => {
        chips.push({ type: 'tag', value: tag, label: tag });
      });
      if (state.priceMin != null || state.priceMax != null) {
        const min = state.priceMin != null ? formatMoney(state.priceMin, moneyFormat) : '0';
        const max = state.priceMax != null ? formatMoney(state.priceMax, moneyFormat) : '∞';
        chips.push({ type: 'price', value: 'price', label: `${min} - ${max}` });
      }

      if (!chips.length) {
        activeFiltersEl.innerHTML = '';
        return;
      }

      activeFiltersEl.innerHTML =
        chips
          .map(
            (chip) =>
              `<button type="button" class="hdt-cpu-active-filter" data-hdt-clear-chip data-type="${escapeAttr(chip.type)}" data-value="${escapeAttr(chip.value)}">
                <span class="hdt-cpu-active-filter__icon" aria-hidden="true">
                  <span class="hdt-cpu-active-filter__x"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 13"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"/></svg></span>
                  <span class="hdt-cpu-active-filter__minus"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 2"><path fill="currentColor" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1"/></svg></span>
                </span>
                <span class="hdt-cpu-active-filter__label">${escapeHtml(chip.label)}</span>
              </button>`
          )
          .join('') +
        `<button type="button" class="hdt-cpu-active-filters__clear" data-hdt-clear-all-filters>
          <span class="hdt-cpu-active-filters__clear-x" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 13"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"/></svg></span>
          <span>${escapeHtml(strings.clearAll)}</span>
        </button>`;
    }

    function bindToolbar() {
      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-hdt-wishlist-filter-open]')) {
          openFilter();
          return;
        }
        if (
          event.target.closest('[data-hdt-wishlist-filter-close]') ||
          event.target.closest('[data-hdt-wishlist-filter-overlay]') ||
          event.target.closest('[data-hdt-wishlist-filter-done]')
        ) {
          closeFilter();
          return;
        }
        if (event.target.closest('[data-hdt-wishlist-filter-clear]')) {
          clearFilters();
          return;
        }
        const chip = event.target.closest('[data-hdt-clear-chip]');
        if (chip) {
          removeChip(chip.dataset.type, chip.dataset.value);
          return;
        }
        if (event.target.closest('[data-hdt-clear-all-filters]')) {
          clearFilters();
          return;
        }
        const densityBtn = event.target.closest('.hdt-cpu-density-switcher__btn');
        if (densityBtn && densitySwitcher?.contains(densityBtn)) {
          setDensity(densityBtn.getAttribute('data-cols'));
          return;
        }
        const sortTrigger = event.target.closest('[data-hdt-wishlist-sort-trigger]');
        if (sortTrigger) {
          toggleSortMenu();
          return;
        }
        const sortOption = event.target.closest('[data-hdt-wishlist-sort-option]');
        if (sortOption) {
          state.sort = sortOption.dataset.value;
          const label = sortRoot?.querySelector('[data-hdt-wishlist-sort-label]');
          if (label) label.textContent = sortOption.textContent.trim();
          closeSortMenu();
          applyView();
        }
      });

      if (densitySwitcher) {
        try {
          const stored = localStorage.getItem(densitySwitcher.dataset.storageKey);
          if (stored) setDensity(stored);
        } catch (e) {
          /* ignore */
        }
      }
    }

    function setDensity(cols) {
      if (!cols || !grid) return;
      grid.style.setProperty('--hdt-cpu-cols', cols);
      grid.style.setProperty('--hdt-cpu-cols-mobile', cols);
      grid.style.setProperty('--hdt-cpu-cols-tablet', cols);
      grid.style.setProperty('--hdt-cpu-cols-desktop', cols);
      densitySwitcher?.querySelectorAll('.hdt-cpu-density-switcher__btn').forEach((btn) => {
        const active = btn.getAttribute('data-cols') === String(cols);
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', String(active));
      });
      try {
        if (densitySwitcher?.dataset.storageKey) {
          localStorage.setItem(densitySwitcher.dataset.storageKey, cols);
        }
      } catch (e) {
        /* ignore */
      }
    }

    function buildSortMenu() {
      if (!sortRoot || sortRoot.querySelector('[data-hdt-wishlist-sort-panel]')) return;
      const panel = document.createElement('div');
      panel.className = 'hdt-sort-dd__panel';
      panel.setAttribute('data-hdt-wishlist-sort-panel', '');
      panel.hidden = true;
      panel.innerHTML = SORT_OPTIONS.map((opt) => {
        const label = strings[opt.labelKey] || opt.value;
        const selected = opt.value === state.sort ? ' is-selected' : '';
        return `<button type="button" class="hdt-sort-dd__option${selected}" data-hdt-wishlist-sort-option data-value="${opt.value}">${escapeHtml(label)}</button>`;
      }).join('');
      sortRoot.appendChild(panel);

      const sheet = document.createElement('div');
      sheet.className = 'hdt-sort-dd__sheet';
      sheet.setAttribute('data-hdt-wishlist-sort-sheet', '');
      sheet.hidden = true;
      sheet.innerHTML = `
        <div class="hdt-sort-dd__overlay" data-hdt-wishlist-sort-overlay></div>
        <div class="hdt-sort-dd__sheet-wrap">
          <button type="button" class="hdt-sort-dd__close" data-hdt-wishlist-sort-close aria-label="${escapeAttr(strings.close)}">
            <span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.433 7.432 7.433a.5.5 0 0 0 .707-.707l-7.433-7.433 7.433-7.432a.5.5 0 0 0-.707-.707L9.005 7.838 1.572.405a.5.5 0 0 0-.707.707L8.298 8.545.865 15.978Z"/></svg></span>
          </button>
          <div class="hdt-sort-dd__sheet-panel">
            ${SORT_OPTIONS.map((opt) => {
              const label = strings[opt.labelKey] || opt.value;
              const selected = opt.value === state.sort ? ' is-selected' : '';
              return `<button type="button" class="hdt-sort-dd__option${selected}" data-hdt-wishlist-sort-option data-value="${opt.value}">${escapeHtml(label)}</button>`;
            }).join('')}
          </div>
        </div>`;
      document.body.appendChild(sheet);

      sheet.addEventListener('click', (event) => {
        if (
          event.target.closest('[data-hdt-wishlist-sort-overlay]') ||
          event.target.closest('[data-hdt-wishlist-sort-close]')
        ) {
          closeSortMenu();
          return;
        }
        const option = event.target.closest('[data-hdt-wishlist-sort-option]');
        if (option) {
          state.sort = option.dataset.value;
          const label = sortRoot.querySelector('[data-hdt-wishlist-sort-label]');
          if (label) label.textContent = option.textContent.trim();
          closeSortMenu();
          applyView();
        }
      });

      document.addEventListener('click', (event) => {
        if (!sortRoot.classList.contains('is-open')) return;
        if (sortRoot.contains(event.target)) return;
        if (event.target.closest('[data-hdt-wishlist-sort-sheet]')) return;
        closeSortMenu();
      });
    }

    function toggleSortMenu() {
      if (sortRoot?.classList.contains('is-open')) closeSortMenu();
      else openSortMenu();
    }

    function openSortMenu() {
      if (!sortRoot) return;
      sortRoot.classList.add('is-open');
      sortRoot.querySelector('[data-hdt-wishlist-sort-trigger]')?.setAttribute('aria-expanded', 'true');
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const panel = sortRoot.querySelector('[data-hdt-wishlist-sort-panel]');
      const sheet = document.querySelector('[data-hdt-wishlist-sort-sheet]');
      if (isMobile) {
        if (panel) panel.hidden = true;
        if (sheet) {
          sheet.hidden = false;
          requestAnimationFrame(() => sheet.classList.add('is-open'));
        }
        document.body.classList.add('overflow-hidden');
      } else if (panel) {
        panel.hidden = false;
        requestAnimationFrame(() => panel.classList.add('is-open'));
      }
    }

    function closeSortMenu() {
      sortRoot?.classList.remove('is-open');
      sortRoot?.querySelector('[data-hdt-wishlist-sort-trigger]')?.setAttribute('aria-expanded', 'false');
      const panel = sortRoot?.querySelector('[data-hdt-wishlist-sort-panel]');
      const sheet = document.querySelector('[data-hdt-wishlist-sort-sheet]');
      panel?.classList.remove('is-open');
      sheet?.classList.remove('is-open');
      setTimeout(() => {
        if (panel && !sortRoot?.classList.contains('is-open')) panel.hidden = true;
        if (sheet && !sortRoot?.classList.contains('is-open')) sheet.hidden = true;
      }, 280);
      document.body.classList.remove('overflow-hidden');
    }

    function buildFilterDrawer() {
      if (!filterBody) return;
      const vendors = [...new Set(state.items.map((i) => i.vendor).filter(Boolean))].sort();
      const tags = [...new Set(state.items.flatMap((i) => i.tags || []))].sort();
      const prices = state.items.map((i) => i.price).filter((p) => p != null);
      const minPrice = prices.length ? Math.min(...prices) : 0;
      const maxPrice = prices.length ? Math.max(...prices) : 0;

      filterBody.innerHTML = `
        ${
          vendors.length
            ? `<details class="hdt-wishlist-filter__group" open>
                <summary class="hdt-wishlist-filter__summary">${escapeHtml(strings.vendor)}</summary>
                <ul class="hdt-wishlist-filter__list">
                  ${vendors
                    .map(
                      (vendor) =>
                        `<li><label class="hdt-wishlist-filter__label"><input type="checkbox" data-filter-vendor value="${escapeAttr(vendor)}" ${state.vendors.has(vendor) ? 'checked' : ''}><span>${escapeHtml(vendor)}</span></label></li>`
                    )
                    .join('')}
                </ul>
              </details>`
            : ''
        }
        ${
          tags.length
            ? `<details class="hdt-wishlist-filter__group" open>
                <summary class="hdt-wishlist-filter__summary">${escapeHtml(strings.tags)}</summary>
                <ul class="hdt-wishlist-filter__list">
                  ${tags
                    .map(
                      (tag) =>
                        `<li><label class="hdt-wishlist-filter__label"><input type="checkbox" data-filter-tag value="${escapeAttr(tag)}" ${state.tags.has(tag) ? 'checked' : ''}><span>${escapeHtml(tag)}</span></label></li>`
                    )
                    .join('')}
                </ul>
              </details>`
            : ''
        }
        ${
          prices.length
            ? `<details class="hdt-wishlist-filter__group" open>
                <summary class="hdt-wishlist-filter__summary">${escapeHtml(strings.price)}</summary>
                <div class="hdt-wishlist-filter__price">
                  <label>${escapeHtml(strings.priceMin)} <input type="number" data-filter-price-min min="0" step="0.01" value="${state.priceMin != null ? state.priceMin / 100 : ''}" placeholder="${(minPrice / 100).toFixed(2)}"></label>
                  <label>${escapeHtml(strings.priceMax)} <input type="number" data-filter-price-max min="0" step="0.01" value="${state.priceMax != null ? state.priceMax / 100 : ''}" placeholder="${(maxPrice / 100).toFixed(2)}"></label>
                </div>
              </details>`
            : ''
        }`;

      filterBody.querySelectorAll('input').forEach((input) => {
        input.addEventListener('change', readFiltersFromDrawer);
        input.addEventListener('input', readFiltersFromDrawer);
      });
    }

    function readFiltersFromDrawer() {
      state.vendors = new Set(
        [...filterBody.querySelectorAll('[data-filter-vendor]:checked')].map((el) => el.value)
      );
      state.tags = new Set([...filterBody.querySelectorAll('[data-filter-tag]:checked')].map((el) => el.value));
      const minInput = filterBody.querySelector('[data-filter-price-min]');
      const maxInput = filterBody.querySelector('[data-filter-price-max]');
      state.priceMin = minInput && minInput.value !== '' ? Math.round(Number(minInput.value) * 100) : null;
      state.priceMax = maxInput && maxInput.value !== '' ? Math.round(Number(maxInput.value) * 100) : null;
      applyView();
    }

    function clearFilters() {
      state.vendors.clear();
      state.tags.clear();
      state.priceMin = null;
      state.priceMax = null;
      buildFilterDrawer();
      applyView();
    }

    function removeChip(type, value) {
      if (type === 'vendor') state.vendors.delete(value);
      if (type === 'tag') state.tags.delete(value);
      if (type === 'price') {
        state.priceMin = null;
        state.priceMax = null;
      }
      buildFilterDrawer();
      applyView();
    }

    function openFilter() {
      if (!filterRoot) return;
      filterRoot.hidden = false;
      requestAnimationFrame(() => filterRoot.classList.add('is-open'));
      document.body.classList.add('overflow-hidden');
    }

    function closeFilter() {
      if (!filterRoot) return;
      filterRoot.classList.remove('is-open');
      setTimeout(() => {
        if (!filterRoot.classList.contains('is-open')) filterRoot.hidden = true;
      }, 280);
      document.body.classList.remove('overflow-hidden');
    }
  }

  function fetchWishlistItem(handle, options) {
    return Promise.all([fetchLiquidCard(handle, options), fetchProductMeta(handle, options)]).then(
      ([liquid, meta]) => {
        const gone = Boolean((liquid && liquid.gone) || (meta && meta.gone));
        if (gone) return { handle, html: null, gone: true };

        if (liquid && liquid.html) {
          return {
            handle,
            html: liquid.html,
            gone: false,
            title: (meta && meta.title) || handle,
            vendor: (meta && meta.vendor) || '',
            tags: (meta && meta.tags) || [],
            price: meta && meta.price != null ? meta.price : null,
            created: (meta && meta.created) || 0,
            available: meta ? meta.available : true,
          };
        }
        if (meta && meta.html) return meta;
        /* Transient failure — keep handle in storage, just skip rendering */
        return { handle, html: null, gone: false };
      }
    );
  }

  function fetchLiquidCard(handle, options) {
    const base = options.rootUrl.endsWith('/') ? options.rootUrl : `${options.rootUrl}/`;
    const section = options.cardSection || 'ajax-card-product-plus-ultra';
    const url = `${base}products/${encodeURIComponent(handle)}?section_id=${encodeURIComponent(section)}`;

    return fetch(url)
      .then((response) => {
        if (response.status === 404) return { handle, html: null, gone: true };
        if (!response.ok) return null;
        return response.text().then((html) => {
          const cardHtml = extractCardHtml(html);
          return cardHtml ? { handle, html: cardHtml, gone: false } : null;
        });
      })
      .catch(() => null);
  }

  function fetchProductMeta(handle, options) {
    const base = options.rootUrl.endsWith('/') ? options.rootUrl : `${options.rootUrl}/`;
    const url = `${base}products/${encodeURIComponent(handle)}.js`;

    return fetch(url, { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (response.status === 404) return { handle, html: null, gone: true };
        if (!response.ok) return null;
        return response.json().then((product) => ({
          handle: product.handle || handle,
          title: product.title || handle,
          vendor: product.vendor || '',
          tags: normalizeTags(product.tags),
          price: product.price != null ? product.price : null,
          created: product.published_at ? Date.parse(product.published_at) : 0,
          available: Boolean(product.available),
          html: buildPlusUltraCard(product, options),
          gone: false,
        }));
      })
      .catch(() => null);
  }

  function normalizeTags(tags) {
    if (Array.isArray(tags)) return tags.map(String).filter(Boolean);
    if (typeof tags === 'string') {
      return tags
        .split(',')
        .map((tag) => tag.trim())
        .filter(Boolean);
    }
    return [];
  }

  function extractCardHtml(html) {
    if (!html || !html.trim()) return null;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const card =
      doc.querySelector('.hdt-cpu-ajax-card .hdt-cpu-card') ||
      doc.querySelector('.hdt-cpu-card') ||
      doc.querySelector('.hdt-cpu-ajax-card');
    if (!card) return null;
    return card.classList.contains('hdt-cpu-card') ? card.outerHTML : card.innerHTML;
  }

  function buildPlusUltraCard(product, options) {
    const variant =
      (product.variants || []).find((item) => item.available) || (product.variants || [])[0] || {};
    const available = Boolean(product.available && variant.id);
    const handle = product.handle;
    const base = options.rootUrl.endsWith('/') ? options.rootUrl : `${options.rootUrl}/`;
    const url = product.url || `${base}products/${handle}`;
    const title = escapeHtml(product.title || '');
    const vendor = product.vendor ? `<div class="hdt-cpu-vendor">${escapeHtml(product.vendor)}</div>` : '';
    const image = product.featured_image || (product.images && product.images[0]) || '';
    const imageSrc = typeof image === 'string' ? image : image.src || '';
    const price = formatMoney(variant.price != null ? variant.price : product.price, options.moneyFormat);
    const compareAt =
      variant.compare_at_price && variant.compare_at_price > variant.price
        ? formatMoney(variant.compare_at_price, options.moneyFormat)
        : '';
    const formId = `hdt-cpu-add-wishlist-${product.id}`;
    const strings = options.strings;

    const media = imageSrc
      ? `<img src="${escapeAttr(imageSrc)}" alt="${escapeAttr(product.title || '')}" class="hdt-cpu-media__image hdt-cpu-media__image--primary" loading="lazy" width="533" height="533">`
      : `<div class="hdt-cpu-media__image placeholder-svg"></div>`;

    const atc = available
      ? `<div class="hdt-cpu-footer-actions hdt-cpu-footer-actions--outside">
          <product-form data-section-id="wishlist" class="hdt-cpu-atc">
            <form method="post" action="${escapeAttr((window.routes && window.routes.cart_add_url) || `${base}cart/add`)}" id="${formId}" class="hdt-cpu-atc__form form" novalidate data-type="add-to-cart-form">
              <input type="hidden" name="id" value="${escapeAttr(variant.id)}" class="product-variant-id">
              <button id="${formId}-submit" type="submit" name="add" class="hdt-cpu-atc__button">
                <span class="hdt-cpu-atc__label">${escapeHtml(strings.addToCart)}</span>
                <div class="loading__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>
              </button>
            </form>
          </product-form>
        </div>`
      : '';

    return `<div class="hdt-cpu-card hdt-cpu-card--atc-outside">
      <div class="hdt-cpu-visual">
        <div class="hdt-cpu-media" style="--ratio-percent: 100%;">
          <a href="${escapeAttr(url)}" class="hdt-cpu-media__link" tabindex="-1" aria-hidden="true">${media}</a>
          <div class="hdt-cpu-float hdt-cpu-float--right">
            <button type="button" class="hdt-cpu-icon-btn hdt-cpu-wishlist hdt-wishlist-toggle is-active" data-hdt-wishlist-toggle="${escapeAttr(handle)}" aria-label="${escapeAttr(strings.wishlist)}" aria-pressed="true">
              <span class="svg-wrapper"><svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M9.5 4.94c.4-.74 1.05-1.38 1.86-1.81a4.3 4.3 0 0 1 4.64.55 4.36 4.36 0 0 1 .5 5.78l-5.57 6.36a1.25 1.25 0 0 1-1.86 0l-5.57-6.36a4.36 4.36 0 0 1 .5-5.78 4.3 4.3 0 0 1 4.64-.55c.81.43 1.46 1.07 1.86 1.81Z"/></svg></span>
            </button>
          </div>
        </div>
        ${atc}
      </div>
      <div class="hdt-cpu-info">
        ${vendor}
        <h3 class="hdt-cpu-title"><a href="${escapeAttr(url)}" class="hdt-cpu-title__link">${title}</a></h3>
        <div class="price hdt-cpu-price${compareAt ? ' price--on-sale' : ''}">
          <div class="price__container">
            ${
              compareAt
                ? `<div class="price__sale"><span><s class="price-item price-item--regular">${escapeHtml(compareAt)}</s></span><span class="price-item price-item--sale">${escapeHtml(price)}</span></div>`
                : `<div class="price__regular"><span class="price-item price-item--regular">${escapeHtml(price)}</span></div>`
            }
          </div>
        </div>
      </div>
    </div>`;
  }

  function formatMoney(cents, format) {
    if (cents == null || cents === '') return '';
    const value = (Number(cents) / 100).toFixed(2);
    const formatString = format || '${{amount}}';
    if (formatString.includes('{{amount_no_decimals}}')) {
      return formatString.replace('{{amount_no_decimals}}', String(Math.round(Number(cents) / 100)));
    }
    if (formatString.includes('{{amount_with_comma_separator}}')) {
      return formatString.replace('{{amount_with_comma_separator}}', value.replace('.', ','));
    }
    return formatString
      .replace('{{amount}}', value)
      .replace('{{amount_no_decimals_with_comma_separator}}', String(Math.round(Number(cents) / 100)));
  }

  function escapeAttr(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
})();
